import { paths } from "@/navigation/paths";
import { assets } from "@/utils/assets";
import { Link } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/ui/LanguageSwitcher";

export const Navbar = () => {
  const { isLoggedIn, user, logout, loginPath } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="w-full h-16 bg-white flex items-center justify-between px-6">
      <Link to={paths.ROOT}>
        <img src={assets.logo} alt="logo" className="h-12" />
      </Link>

      <div className="flex items-center gap-4">
        <LanguageSwitcher />

      {isLoggedIn && user ? (
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-end">
            <span className="text-sm font-medium text-gray-900">
              {user.name} {user.surname}
            </span>
            <span className="text-xs text-gray-500">{user.phone}</span>
          </div>
          <button
            type="button"
            onClick={logout}
            className="text-sm bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
          >
            {t("navbar.logout")}
          </button>
        </div>
      ) : (
        <Link
          to={loginPath}
          className="text-sm bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-700"
        >
          {t("navbar.login")}
        </Link>
      )}
      </div>
    </div>
  );
};
